import React from "react"
import { CarouselComponent } from "../CarouselComponent"

export const AmazonWelcomeComponent = () => {
  return (
    <CarouselComponent height="100vh" bgPosition="top center" images={["/images/Amazon/Amazon_LP-desktop.jpg"]}>
        <div className="row">
          <div className="col mx-auto">
            <p className="text-center title-amazon">New T-Mobile Home Internet customers can get the Echo Show 8 (2nd Gen) ON US</p>
          </div>
        </div>
    </CarouselComponent>
  )
}
